<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";


const { t } = useI18n();
interface IValidateItemProps {
    item: Item;
}

interface Item {
    field: string;
    oldValue: string | null;
    newValue: string | null;
}

// biome-ignore lint/correctness/noUnusedVariables: Init Biome
const emit = defineEmits<(e: "validatedItem") => void>();

const props = defineProps<IValidateItemProps>();

const isNewData = computed(() => props.item.newValue && !props.item.oldValue);
const isDeletedData = computed(() => !props.item.newValue && props.item.oldValue);
</script>
<template>
    <div>
        <div class="compare" v-if="isNewData || isDeletedData">
            <div class="content-container">
                <div class="oneData" :class="{ isDeletedData }">
                    <i :class="`ti ti-${isNewData ? 'new-section' : 'line-scan'}`"></i>
                    <span>{{ t(`page.worker.askedChanges.${isNewData ? "newData" : "deletedData"}`) }}</span>
                </div>
                <div class="content" :class="{ isDeletedData, isNewData }">{{ isNewData ? item.newValue : item.oldValue }}</div>
            </div>
        </div>

        <div class="compare" v-else>
            <div class="content-container">
                <span>{{ t("page.worker.askedChanges.oldVersion") }}</span>
                <div class="content">{{ item.oldValue }}</div>
            </div>
            <div class="new-change">
                <i :class="`ti ti-corner-down-right`"></i>
                <div class="content-container">
                    <span>{{ t("page.worker.askedChanges.newVersion") }}</span>
                    <div class="content isNewData">
                        {{ item.newValue }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.compare {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.content {
    padding: 12px;
    border-radius: 8px;
    flex: 1;

    border: 1px solid $stroke-sub-300;

    &.isNewData {
        box-shadow: 0px 0px 0px 3px $blue-200;
        border: 1px solid $blue-base;
    }

    &.isDeletedData {
        border: 1px solid $red-base;
        box-shadow: 0px 0px 0px 3px $red-200;
    }
}

.content-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    color: $text-main-900;

    /* Texte/xm/Medium */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
}

.new-change {
    display: flex;
    gap: 12px;
    color: $primary-base;
    > .content-container {
        > span {
            color: $primary-base;
        }
    }
}

.oneData {
    display: flex;
    align-items: center;

    gap: 12px;

    color: $primary-base;

    > i {
        font-size: 18px;
    }

    &.isDeletedData {
        color: $red-base;
    }
}

.button-container {
    width: 100%;
    justify-content: center;

    display: flex;
    gap: 18px;
}
</style>
